import { FormBase } from 'core/components';

export default class PalletizeFulfillmentOrderForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseId',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'palletId',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.PALLET',
					rules: 'required',
				},
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.TRACKINGNUMBER',
				},
			],
		};
	}
}
